module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-hh.0b064756.png";